// utils/flattenMenuData.js
export const flattenMenuData = (menuData) => {
    let flatList = [];

    if (!Array.isArray(menuData)) {
      return flatList;
    }

    menuData.forEach((entry) => {
      if (!entry) {
        return;
      }

      if (entry.isCategory && Array.isArray(entry.items)) {
        entry.items.forEach((item) => {
          if (!item) {
            return;
          }

          flatList.push({
            label: item.text || item.title || '',
            path: item.path,
          });

          if (Array.isArray(item.subItems)) {
            item.subItems.forEach((subItem) => {
              flatList.push({
                label: subItem.text || subItem.title || '',
                path: subItem.path,
              });
            });
          }
        });
        return;
      }

      flatList.push({
        label: entry.text || entry.title || '',
        path: entry.path,
      });
    });

    return flatList;
  };
  
